import React from "react";
import ReactDOM from "react-dom/client";
import { MPCWidget } from "./lib/main";
import {
  CallbackProps,
  MiscProps,
  WidgetProvider,
} from "@/lib/context/widget-provider";
import css from "./lib/styles/index.css?inline";

export function renderWidget(
  target: HTMLElement,
  props: CallbackProps & MiscProps,
) {
  const root = target.shadowRoot ?? target.attachShadow({ mode: "open" });

  // Inject CSS into shadow root
  const style = document.createElement("style");
  style.textContent = css;
  root.appendChild(style);

  const container = document.createElement("div");
  root.appendChild(container);

  ReactDOM.createRoot(container).render(
    <WidgetProvider {...props}>
      <MPCWidget />
    </WidgetProvider>,
  );
}

/* window.MPCWidget = {
  render: renderWidget,
};
 */
// Optional: auto-init if div exists
/* if (typeof window !== "undefined") {
  const el = document.getElementById("mpc-widget");
  if (el)
    renderWidget(el, {
      baseUrl: "http://localhost:3000",
      onGetAddresses: addresses => {
        console.log("onGetAddresses", addresses);
      },
      onGetBalance: balances => {
        console.log("onGetBalance", balances);
      },
      onWidgetOpenChange: isOpen => {
        console.log("onWidgetOpenChange", isOpen);
      },
      stytchPublicToken:
        "public-token-test-910c8b48-7956-42b5-9574-252842707fc4",
    });
}
 */
